export default __webpack_public_path__ + "static/media/mail.76caef86.svg";